export default __webpack_public_path__ + "static/media/Table.4d23f2e0.webp";